var exports = {
  "p": "date__08r9li",
};

module.exports = exports;
